import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

export default function LoadingScreen() {
  const [isLoading, setIsLoading] = useState(true)
  const [progress, setProgress] = useState(0)
  const [systemMessage, setSystemMessage] = useState('INITIALIZING SYSTEM')

  useEffect(() => {
    // Text sequence timer
    const textTimer1 = setTimeout(() => {
      setSystemMessage('LOADING CORE MODULES')
    }, 1000)
    
    const textTimer2 = setTimeout(() => {
      setSystemMessage('INITIALIZING ENGINE')
    }, 2000)
    
    const textTimer3 = setTimeout(() => {
      setSystemMessage('LOADING ASSETS')
    }, 3000)
    
    const textTimer4 = setTimeout(() => {
      setSystemMessage('CONNECTING TO SERVER')
    }, 4000)
    
    const textTimer5 = setTimeout(() => {
      
      setSystemMessage('INITIALIZING USER INTERFACE')
    }, 5000)
    
    const textTimer6 = setTimeout(() => {
      setSystemMessage('INITIALIZING PORTFOLIO')
    }, 3000)

    // Progress timer
    const progressTimer = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(progressTimer)
          setTimeout(() => setIsLoading(false), 500)
          return 100
        }
        return prev + Math.random() * 15
      })
    }, 100)

    return () => {
      clearInterval(progressTimer)
      clearTimeout(textTimer1)
      clearTimeout(textTimer2)
      clearTimeout(textTimer3)
      clearTimeout(textTimer4)
      clearTimeout(textTimer5)
      clearTimeout(textTimer6)
    }
  }, [])

  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="fixed inset-0 z-50 bg-dark-900 flex items-center justify-center"
        >
          <div className="text-center space-y-8">

            {/* Loading Text */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.5 }}
              className="space-y-4"
            >
              <motion.div 
                key={`loading-${systemMessage}`}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="text-2xl font-mono text-neon-blue"
              >
                <span className="loading-dots">
                  {systemMessage}
                </span>
              </motion.div>
              
              <motion.div 
                className="text-lg font-mono text-gray-300"
                animate={{ opacity: [0.5, 1, 0.5] }}
                transition={{ duration: 2, repeat: Infinity }}
              >
                Preparing your experience...
              </motion.div>
            </motion.div>

            {/* Progress Bar */}
            <motion.div
              initial={{ opacity: 0, scaleX: 0 }}
              animate={{ opacity: 1, scaleX: 1 }}
              transition={{ duration: 1, delay: 0.8 }}
              className="w-80 h-2 bg-dark-700 rounded-full overflow-hidden mx-auto"
            >
              <motion.div
                className="h-full bg-gradient-to-r from-neon-green via-neon-blue to-neon-pink rounded-full relative"
                style={{ width: `${progress}%` }}
                transition={{ duration: 0.3 }}
              >
                <motion.div
                  animate={{
                    x: ['-100%', '100%']
                  }}
                  transition={{
                    duration: 1.5,
                    repeat: Infinity,
                    ease: 'linear'
                  }}
                  className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-30"
                />
              </motion.div>
            </motion.div>

            {/* Progress Percentage */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1, delay: 1 }}
              className="text-2xl font-mono text-neon-green"
            >
              {Math.round(progress)}%
            </motion.div>

            {/* Matrix Effect */}
            <div className="absolute inset-0 pointer-events-none">
              {[...Array(20)].map((_, i) => (
                <motion.div
                  key={i}
                  className="absolute w-0.5 h-8 bg-neon-green opacity-20"
                  style={{
                    left: `${Math.random() * 100}%`,
                    top: `${Math.random() * 100}%`
                  }}
                  animate={{
                    y: [0, -100],
                    opacity: [0, 1, 0]
                  }}
                  transition={{
                    duration: 2,
                    repeat: Infinity,
                    delay: Math.random() * 2,
                    ease: 'linear'
                  }}
                />
              ))}
            </div>

            {/* Scanlines */}
            <div className="absolute inset-0 scanlines pointer-events-none" />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}


